import { render } from "./LegoBackBtn.vue?vue&type=template&id=68ea5ad0&scoped=true"
import script from "./LegoBackBtn.vue?vue&type=script&lang=js"
export * from "./LegoBackBtn.vue?vue&type=script&lang=js"

import "./LegoBackBtn.vue?vue&type=style&index=0&id=68ea5ad0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68ea5ad0"

export default script